import {get, post} from './request';
import {F, identity, prop, T} from 'ramda';

/** @typedef { import('axios').AxiosRequestConfig } AxiosRequestConfig */

/**
 * Get basket items count
 *
 * @param {AxiosRequestConfig?} config Optional axios configuration
 * @returns {Promise<number>}
 */
export const getBasketItemsCount = (config) =>
    get(
        '/api/basket/count/',
        config,
    )
        .then(prop('count'))
        .catch(identity);

/**
 * Send request to get Over-18-Year-Old cookie to allow user to see adult content
 *
 * @param {AxiosRequestConfig?} config Optional axios configuration
 * @returns {Promise<boolean>}
 */
export const setUserOver18YearsOld = (config) =>
    post(
        '/api/other/confirmAge/',
        config
    )
        .then(T)
        .catch(F);
